export const PROJECT_DEPLOYMENT_STATUS = {
  not_requested: {
    label: "Pendiente",
    severity: "default",
    description: "La publicación automática todavía no fue solicitada.",
  },
  not_configured: {
    label: "Render sin configurar",
    severity: "warning",
    description: "Faltan credenciales o variables de Render en el backend.",
  },
  provisioning: {
    label: "Publicando",
    severity: "info",
    description: "Render está construyendo y preparando la página pública.",
  },
  live: {
    label: "Publicada",
    severity: "success",
    description: "La página ya está disponible públicamente.",
  },
  failed: {
    label: "Falló la publicación",
    severity: "error",
    description: "Render no pudo completar el último despliegue.",
  },
};

export function normalizeProjectPublicUrl(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";

  try {
    const parsed = new URL(raw.includes("://") ? raw : `https://${raw}`);
    return parsed.toString().replace(/\/$/, "");
  } catch {
    return "";
  }
}

export function getProjectRenderUrl(project) {
  return normalizeProjectPublicUrl(project?.deployment?.url);
}

export function getProjectPublicUrl(project) {
  const renderUrl = getProjectRenderUrl(project);
  if (renderUrl) return renderUrl;

  const domain = Array.isArray(project?.domains)
    ? project.domains.find(Boolean)
    : "";

  return normalizeProjectPublicUrl(domain);
}

export function getProjectPublicDomain(project) {
  const url = getProjectPublicUrl(project);
  if (!url) return "";

  try {
    return new URL(url).hostname;
  } catch {
    return "";
  }
}

export function getProjectDeploymentStatus(project) {
  const status = String(project?.deployment?.status || "not_requested");
  return PROJECT_DEPLOYMENT_STATUS[status]
    ? status
    : "not_requested";
}

export function getProjectDeploymentMeta(project) {
  const status = getProjectDeploymentStatus(project);
  return {
    status,
    ...PROJECT_DEPLOYMENT_STATUS[status],
  };
}

export function isProjectDeploymentPending(project) {
  return ["not_requested", "provisioning"].includes(
    getProjectDeploymentStatus(project)
  );
}

export function canRetryProjectDeployment(project) {
  return ["not_requested", "not_configured", "failed"].includes(
    getProjectDeploymentStatus(project)
  );
}
